<!-- @format -->

<div class="composite-rule">
  <div class="rule-header">
    @if (showCountPhrase) {
      <sis-count-phrase [rule]="compositeRule" [ruleValidationResult]="ruleValidationResult"></sis-count-phrase>
    }
  </div>
  <div class="rule-body">
    @for (rule of sortedRules; track rule) {
      <div class="{{ subRuleClassesByLocalId[rule.localId] }}">
        <sis-rule-select
          [rule]="rule"
          [parentModule]="parentModule"
          [validatablePlan]="validatablePlan"
          [planValidationResult]="planValidationResult"
          [blockLevel]="blockLevel + 1"
          [planStateObject]="planStateObject"
          [planData]="planData"
          [uiStateObject]="uiStateObject">
        </sis-rule-select>
      </div>
    }
  </div>
</div>
